<script>
	import { fileContentChecker, isVideoFile } from "src/utils/misc";
	import VideoPlayer from "../VideoPlayer/VideoPlayer.svelte";

	export let slideNo;
	export let totalSlides;
	export let image;
	export let altTag;
	export let attr;
</script>

<!-- Full-width images with number text -->
<div class="mySlides">
	<div class="numbertext">{slideNo} / {totalSlides}</div>
	{#if isVideoFile(image)}
		<VideoPlayer url={fileContentChecker(image)} />
	{:else}
		<img src={fileContentChecker(image)} alt={altTag} title={attr} />
	{/if}
</div>

<style>
	/* Number text (1/3 etc) */
	.numbertext {
		color: #ddd;
		font-size: 0.9rem;
		padding: 8px 12px;
		text-shadow: 1px 1px black;
		position: absolute;
		top: 0;
	}

	img {
		width: 100%;
		max-height: 80vh;
		object-fit: contain;
	}
</style>
